import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { switchMap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    console.log(this.auth.authenticated);
    if (this.auth.authenticated) {

      return true;
    } else {
      this.auth.user$.subscribe(user => {
        if (user) {
          console.log(user);
          if (user.emailVerified) {
            this.router.navigate(["home"]);
            return true;
          }
          else {
            this.router.navigate(["auth/login"]);
            return false;
          }
        }
        else {
          console.log("access denied!");
          this.router.navigate(["auth/login"]);
          return false;
        }
      });
    }



  }
}

// checkLogin(url: string): boolean {
//   console.log("entro a checklogin");
//   let loggedin:boolean;
//   console.log("1");
//   this.auth.user$.pipe(
//     switchMap(auth => {
//
//     console.log("hola");
//     if(auth == null) {
//       this.router.navigate(['/login']);
//       return false;
//     } else {
//       return true;
//     }
//   })
// )
//
//
//   // Store the attempted URL for redirecting
//   //this.authService.redirectUrl = url;
//
//   // Navigate to the login page with extras
//   // this.router.navigate(['/login']);
//     console.log(loggedin);
//    return loggedin;
// }
